// import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
const isBrowser = typeof window !== 'undefined';
const { Editor } = isBrowser ? require('react-draft-wysiwyg') : { Editor: undefined };
export { EditorState };
export default Editor;
